import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromTournamentReducer from '../reducers/tournament.reducer';

export const selectState = createFeatureSelector<fromTournamentReducer.State>(
  fromTournamentReducer.featureKey
);

export const getSeasons = createSelector(selectState, (state) => state.seasons);
export const getLeagues = createSelector(selectState, (state) => state.leagues);
export const getLeagueDetails = createSelector(selectState, (state) => state.leagueDetails);
export const getLeagueGames = createSelector(selectState, (state) => state.leagueGames);
export const getLeaguePlayers = createSelector(selectState, (state) => state.leaguePlayers);